import { WorkerPreferenceSection } from './worker-preference-section';

export const WorkerPreferencesTab = () => {
  return (
    <div className="flex flex-col items-start gap-6">
      <WorkerPreferenceSection />
    </div>
  );
};
